/*
      * @param: obj - 对象
      * @return: Object{
		  sortObj[key值按照字母排序的对象]
		  sortObjStr[把排序好的对象用字符串连起来]
	  }
  */
const getObjKeySort = function(obj) {
  if (Object.prototype.toString.call(obj).slice(8, -1) !== 'Object') {
    // throw new Error('参数必须是一个对象');
    return
  }
  var newkey = Object.keys(obj).sort()
  var objStrArr = []
  //先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组
  var newObj = {} //创建一个新的对象，用于存放排好序的键值对
  for (var i = 0; i < newkey.length; i++) {
    //遍历newkey数组
    newObj[newkey[i]] = obj[newkey[i]] //向新创建的对象中按照排好的顺序依次增加键值对
    obj[newkey[i]] != null && objStrArr.push(`${newkey[i]}=${obj[newkey[i]]}&`)
  }

  return {
    sortObj: newObj, //返回排好序的新对象
    sortObjStr: objStrArr.join(''),
  }
}

/**
 * 日期格式化
 * @param date
 * @param format YYYY年MM月dd日hh时mm分ss秒
 * @returns {string}
 */
const dateToyyyymmdd = function(date, format) {
  var time = ''
  try {
    var d = new Date(date)
    var YYYY = d.getFullYear()
    var M = d.getMonth() + 1
    var D = d.getDate()
    var h = d.getHours()
    var m = d.getMinutes()
    var s = d.getSeconds()

    time = format.replace('YYYY', YYYY)
    var MM = M < 10 ? '0' + M : M
    time = time.replace('MM', MM)
    var DD = D < 10 ? '0' + D : D
    time = time.replace('dd', DD)
    var hh = h < 10 ? '0' + h : h
    time = time.replace('hh', hh)
    var mm = m < 10 ? '0' + m : m
    time = time.replace('mm', mm)
    var ss = s < 10 ? '0' + s : s
    time = time.replace('ss', ss)
  } catch (err) {
    console.log(err)
  }
  return time
}

const formatSeconds = function(a) {
  // 将秒数格式化
  var length = ''
  var hh = parseInt(a / 3600)
  if (hh < 10) hh = '0' + hh
  var mm = parseInt((a - hh * 3600) / 60)
  if (mm < 10) mm = '0' + mm
  var ss = parseInt((a - hh * 3600) % 60)
  if (ss < 10) ss = '0' + ss

  if (hh > 0) {
    length += hh + ':'
  }
  if (mm > 0) {
    length += mm + ':' + ss
  } else {
    length += '0:' + ss
  }

  if (a > 0) {
    return length
  }
}

export { getObjKeySort, dateToyyyymmdd, formatSeconds }
